export default __webpack_public_path__ + "static/media/donacion_alimento.b9c570cb.png";